import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMinus = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("rect", {
		x: 3.79492,
		y: 9.29004,
		width: 12.5,
		height: 1.63065,
		rx: .815323,
		fill: "currentColor"
	})
});
const ForwardRef = forwardRef(SvgMinus);
export default ForwardRef;
